var path = 'app/scripts/modules/core/src/widgets/actionIcons/actionIcons.component.html';
var html = "<div class=\"actions\">\n  <button class=\"btn btn-xs btn-link\"\n          ng-click=\"$ctrl.edit()\">\n    <span class=\"glyphicon glyphicon-cog\" uib-tooltip=\"{{:: $ctrl.editInfo }}\"></span>\n    <span class=\"sr-only\">{{:: $ctrl.editInfo }}</span>\n  </button>\n  <button ng-click=\"$ctrl.destroy()\"\n          class=\"btn btn-xs btn-link\">\n    <span class=\"glyphicon glyphicon-trash\" uib-tooltip=\"{{:: $ctrl.destroyInfo }}\"></span>\n    <span class=\"sr-only\">{{:: $ctrl.destroyInfo }}</span>\n  </button>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/widgets/actionIcons/actionIcons.component.html
// module id = 1093
// module chunks = 0